import { TimeSlot } from '@mnspro-cloud/services';
import moment from 'moment';
import { OptionalNullable } from '../../Utils/types/OptionalNullable';

interface AbsenceLike {
  timeSlotStart?: OptionalNullable<TimeSlot> | null;
  timeSlotEnd?: OptionalNullable<TimeSlot> | null;
  start?: string | null;
  end?: string | null;
}

/**
 * Formats the date & time range of the given absence
 */
export const formatAbsenceDate = (absence: AbsenceLike): string => {
  if (
    !absence.timeSlotStart ||
    !absence.timeSlotEnd ||
    !absence.start ||
    !absence.end
  ) {
    // Absences should always have an start/end date & timeslot
    return '';
  }

  // Fall 1: Gleiche Stunde (z.B. "3. Std. 09:40 - 10:25")
  if (absence.timeSlotStart.name === absence.timeSlotEnd.name) {
    return `${absence.timeSlotStart.name} ${absence.timeSlotStart.start} - ${absence.timeSlotEnd.end}`;
  }

  const momentStart = moment(absence.start);
  const momentEnd = moment(absence.end);

  // Fall 2: Gleicher Tag, unterschiedliche Stunden
  if (momentStart.clone().utc().isSame(momentEnd.clone().utc(), 'day')) {
    return `${absence.timeSlotStart.name} ${absence.timeSlotStart.start} - ${absence.timeSlotEnd.name} ${absence.timeSlotEnd.end}`;
  }

  // Fall 3: Unterschiedliche Tage
  const startDay = momentStart.format('L');
  const endDay = momentEnd.format('L');

  return `${startDay} ${absence.timeSlotStart.name} ${absence.timeSlotStart.start} - ${endDay} ${absence.timeSlotEnd.name} ${absence.timeSlotEnd.end}`;
};
